import { API_URL, createRequestActionTypes } from "../../../../../../actions/utilAction";

export const POST_DOWNLOADBEHAVIORSFORRAWDATA = `${API_URL}/api/MasterDataDefaultTargetSetting/DownloadBehaviorsForRawData`;
export const GET_CLIENTSFORBEHAVIORDOWNLOAD = `${API_URL}/api/MasterDataDefaultTargetSetting/GetClientsForBehaviorDownload`;
export const GET_BEHAVIORSBYCLIENTIDS = `${API_URL}/api/MasterDataDefaultTargetSetting/GetBehaviorsByClientIds`;
export const POST_DOWNLOAD_TARGET_FOR_UPLOADING_RAW_DATA = `${API_URL}/api/MasterDataDefaultTargetSetting/DownloadTargetsForUploadingRawData`;


export const DownloadBehaviorsActionTypes = {
    post_DownloadBehaviorsForRawData: createRequestActionTypes('POST_DOWNLOAD_BEHAVIORS_FOR_RAW_DATA'),
    get_ClientsForBehaviorDownload: createRequestActionTypes('GET_CLIENTS_FOR_BEHAVIOR_DOWNLOAD'),
    get_BehaviorsByClientIds: createRequestActionTypes('GET_BEHAVIORS_BY_CLIENT_IDS'),
    get_downloadTargetRawData: createRequestActionTypes('GET_DOWNLOADTARGETRAWDATA'),
    pst_DownloadTargetForUploadingRawData: createRequestActionTypes('POST_DOWNLOAD_TARGET_FOR_UPLOADING_RAW_DATA'),
}; 


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/downloadTargetsBehaviors/constants/downloadBehaviorsForRawDataConstant.js